import {useEffect, useState} from 'react';
import {  connect } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Cookies from 'js-cookie';
import base64 from 'base-64';
import utf8 from 'utf8';
import moment from "moment";
import { loginUser } from '../../redux/auth/action';
import IntlMessages from '../../utils/IntlMessages';

const Login = ({ loginUser, auth }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { loading, error } = auth;

     useEffect(() => {
       if (Cookies.get('browserID') === '' || Cookies.get('browserID') === null || Cookies.get('browserID') === undefined) {
        setBrowserID()
        }
    },[])

   const setBrowserID = () => {
    let cData = "" + moment().tz("UTC").unix() + Math.floor(Math.random() * 10000000000);
    Cookies.set('browserID', cData);
  }
  
  const getBrowserID = () => {
   return Cookies.get('browserID') ? Cookies.get('browserID')  : null;
  }

  // Formik configuration
  const formik = useFormik({
    initialValues: {
      username: '',
      password: '',
    },
    validationSchema: Yup.object({
      username: Yup.string()
        .required(t('username_required')), // Use a translation key for username required
      password: Yup.string()
        .min(6, t('password_min')) // Translation for password minimum length
        .required(t('password_required')), // Translation for required password
    }),
    onSubmit:(formData, { setSubmitting, setFieldValue }) => {
            
            let encodedUtf8Username = utf8.encode(formData.username);
            let encodedUtf8Password = utf8.encode(formData.password);
  
            let encodedUsername = base64.encode(encodedUtf8Username);
            let encodedPassword = base64.encode(encodedUtf8Password);
            formData.browserID = getBrowserID()
            let params = {
              username : encodedUsername,
              password : encodedPassword,
              browserID : formData.browserID,
              isApp : formData.isApp
            }

            loginUser(params, setSubmitting, setFieldValue, history, '/')
            },
  });

  return (
    <div className="container mt-5" style={{ maxWidth: '400px' }}>
      <h3 className="mb-4 text-center">{t('welcome')}</h3>
      <form onSubmit={formik.handleSubmit}>
        <div className="form-group mb-3">
          <label>{t('username')}</label>
          <input
            type="text"
            className={`form-control ${
              formik.touched.username && formik.errors.username ? 'is-invalid' : ''
            }`}
            name="username"
            value={formik.values.username}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {formik.touched.username && formik.errors.username && (
            <div className="invalid-feedback">{formik.errors.username}</div>
          )}
        </div>

        <div className="form-group mb-3">
          <label>
            <IntlMessages id="login_password" />
          </label>
          <input
            type="password"
            className={`form-control ${
              formik.touched.password && formik.errors.password ? 'is-invalid' : ''
            }`}
            name="password"
            value={formik.values.password}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {formik.touched.password && formik.errors.password && (
            <div className="invalid-feedback">{formik.errors.password}</div>
          )}
        </div>

        {error && <div className="alert alert-danger">{error}</div>}
        <button
          className="btn btn-primary w-100"
          type="submit"
          disabled={loading}
        >
          {loading ? t('logging_in') : t('login')}
        </button>
      </form>
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { loginUser })(Login);